/*
  Dishclosure cart rules. Loaded on every page from snippets/dc-config.liquid.

  The store sells three guides and one bundle of all three, so a cart only ever
  needs one of each guide, or the bundle instead of the guides:
    - a guide is never added twice
    - adding the bundle removes the single guides it already contains
    - adding a guide when the bundle is in the cart changes nothing
    - holding every single guide swaps them for the bundle when that is cheaper

  Any link with data-dc-buy="VARIANT_ID" adds that variant and opens the cart page.
  The link's own href does the same job without JavaScript.
*/
(function () {
  var cfg = window.DC;
  if (!cfg) return;

  var bundle = cfg.bundle;
  var guides = cfg.guides || [];
  var busy = false;
  var SWITCH_KEY = 'dcSwitchedToBundle';
  var NORMALIZE_KEY = 'dcNormalizedAt';

  function request(url, body) {
    var options = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed: ' + response.status);
      return response.json();
    });
  }

  function isGuide(id) {
    return guides.some(function (guide) {
      return guide.id === id;
    });
  }

  function quantities(cart) {
    var map = {};
    cart.items.forEach(function (item) {
      map[item.variant_id] = (map[item.variant_id] || 0) + item.quantity;
    });
    return map;
  }

  // What the cart should hold once `adding` (a variant id, or null) is in it.
  // `updates` are quantity corrections; `add` is the one variant still to add.
  function plan(cart, adding) {
    var have = quantities(cart);
    var updates = {};
    var add = null;
    var switched = false;

    var wantBundle = !!bundle && (have[bundle.id] > 0 || adding === bundle.id);
    var singles = guides.filter(function (guide) {
      return have[guide.id] > 0 || adding === guide.id;
    });

    if (!wantBundle && bundle && guides.length > 1 && singles.length === guides.length) {
      var singlesTotal = singles.reduce(function (sum, guide) {
        return sum + guide.price;
      }, 0);
      if (bundle.price < singlesTotal) {
        wantBundle = true;
        switched = true;
      }
    }

    function settle(id, target) {
      var current = have[id] || 0;
      if (current === target) return;
      if (current === 0 && target === 1) add = id;
      else updates[id] = target;
    }

    guides.forEach(function (guide) {
      var keep = !wantBundle && singles.indexOf(guide) !== -1;
      settle(guide.id, keep ? 1 : 0);
    });
    if (bundle) settle(bundle.id, wantBundle ? 1 : 0);

    return { updates: updates, add: add, switched: switched };
  }

  cfg.plan = plan; // exposed for the regression tests in tests/

  // Corrections go through update.js; the new item goes through add.js so the
  // storefront's own "added to cart" tracking still sees it.
  function apply(steps) {
    var chain = Promise.resolve();
    if (Object.keys(steps.updates).length) {
      chain = chain.then(function () {
        return request(cfg.updateJs, { updates: steps.updates });
      });
    }
    if (steps.add) {
      chain = chain.then(function () {
        return request(cfg.addJs, { items: [{ id: steps.add, quantity: 1 }] });
      });
    }
    return chain.then(function () {
      return steps;
    });
  }

  function remember(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      /* storage can be unavailable in private windows; the cart still works */
    }
  }

  function recall(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function forget(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      /* see remember() */
    }
  }

  function onCartPage() {
    return window.location.pathname.replace(/\/$/, '') === cfg.cartUrl.replace(/\/$/, '');
  }

  function openCart() {
    if (onCartPage()) window.location.reload();
    else window.location.href = cfg.cartUrl;
  }

  function buy(id, link) {
    if (busy) return;
    busy = true;
    link.setAttribute('data-dc-busy', '');
    link.setAttribute('aria-busy', 'true');

    var known = (bundle && bundle.id === id) || isGuide(id);

    request(cfg.cartJs)
      .then(function (cart) {
        if (known) return apply(plan(cart, id));
        // A product outside the guide set: add it as it is.
        return request(cfg.addJs, { items: [{ id: id, quantity: 1 }] }).then(function () {
          return { switched: false };
        });
      })
      .then(function (steps) {
        if (steps.switched) remember(SWITCH_KEY, '1');
        openCart();
      })
      .catch(function () {
        // Let the plain link do the job instead.
        window.location.href = link.getAttribute('href') || cfg.cartUrl;
      });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-dc-buy]');
    if (!link) return;
    // Leave new-tab and new-window clicks to the browser.
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var id = parseInt(link.getAttribute('data-dc-buy'), 10);
    if (!id) return;
    event.preventDefault();
    buy(id, link);
  });

  // The cart section marks itself when the server-rendered cart breaks a rule
  // (a quantity above 1, the bundle next to a single, every single guide).
  function normalize() {
    if (!document.querySelector('[data-dc-normalize]')) return;
    var last = parseInt(recall(NORMALIZE_KEY) || '0', 10);
    if (Date.now() - last < 5000) return; // never loop if a correction did not stick
    request(cfg.cartJs)
      .then(function (cart) {
        var steps = plan(cart, null);
        if (!Object.keys(steps.updates).length && !steps.add) return null;
        remember(NORMALIZE_KEY, String(Date.now()));
        return apply(steps);
      })
      .then(function (steps) {
        if (!steps) return;
        if (steps.switched) remember(SWITCH_KEY, '1');
        window.location.reload();
      })
      .catch(function () {
        /* the cart stays as the shopper left it */
      });
  }

  function showSwitchNotice() {
    var notice = document.querySelector('[data-dc-switched]');
    if (!notice || !recall(SWITCH_KEY)) return;
    forget(SWITCH_KEY);
    notice.hidden = false;
  }

  function ready() {
    normalize();
    showSwitchNotice();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();

  // A page restored by the Back button keeps its old state: re-enable the
  // buttons, and re-read the cart page so its totals are never stale.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (onCartPage()) {
      window.location.reload();
      return;
    }
    busy = false;
    Array.prototype.forEach.call(document.querySelectorAll('[data-dc-busy]'), function (link) {
      link.removeAttribute('data-dc-busy');
      link.removeAttribute('aria-busy');
    });
  });
})();
